import React from "react";
import OrtivisEndQuizMultiplayer from "./endQuiz/ortivis/OrtivisEndQuizMultiplayer";

const EndQuizMultiplayer = ({ quizId, room, questions }) => {
	if (quizId === "bb792d8c-5be1-4a72-9ebd-8807dee0d79d") {
		return (
			<OrtivisEndQuizMultiplayer
				quizId={quizId}
				room={room}
				questions={questions}
			/>
		);
	}
};

export default EndQuizMultiplayer;
